import Helmet from "react-helmet";

export const EvidonScripts = () => (
  <Helmet>
    <script companyid="2796" src="https://c.evidon.com/dg/dg.js" />
  </Helmet>
);
